var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96924 12.0308L5.97016 12.0317C6.11641 12.1765 6.30823 12.25 6.50002 12.25C6.69181 12.25 6.88363 12.1765 7.02989 12.0317L14.0313 5.03034C14.3233 4.73682 14.3233 4.26322 14.0313 3.96969L14.0303 3.96879C13.7368 3.67676 13.2628 3.67723 12.9692 3.96925L6.50003 10.4394L3.03035 6.96879C2.73682 6.67676 2.26322 6.67676 1.9697 6.96879L1.9688 6.96969C1.67677 7.26322 1.67722 7.73727 1.96925 8.03079L5.96924 12.0308ZM2.47315 7.00048C2.35425 7.00683 2.23716 7.05534 2.14602 7.14602C1.95102 7.34202 1.95102 7.65802 2.14602 7.85402L6.14602 11.854C6.24402 11.951 6.37202 12 6.50002 12C6.50906 12 6.5181 11.9998 6.52713 11.9993C6.51817 11.9998 6.50921 12 6.50025 12C6.37225 12 6.24425 11.951 6.14625 11.854L2.14625 7.85401C1.95125 7.65801 1.95125 7.34201 2.14625 7.14601C2.23733 7.05539 2.35432 7.00688 2.47315 7.00048ZM13.4731 4.00048C13.3542 4.00683 13.2372 4.05534 13.146 4.14602L6.50014 10.7929L6.50025 10.793L13.1462 4.14601C13.2373 4.05539 13.3543 4.00688 13.4731 4.00048Z",
    fill: "#0FBC71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIcon);
export default __webpack_public_path__ + "static/media/greenTickIcon.212fefda6a8921e0976c1fbe74278b63.svg";
export { ForwardRef as ReactComponent };